import { render, staticRenderFns } from "./add-member.vue?vue&type=template&id=3251dd1f&"
import script from "./add-member.ts?vue&type=script&lang=js&"
export * from "./add-member.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports